"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayoutWidthArray = exports.LayoutWidth = void 0;
var LayoutWidth;
exports.LayoutWidth = LayoutWidth;

(function (LayoutWidth) {
  LayoutWidth["FULL_WIDTH"] = "full-width";
  LayoutWidth["IN_SET"] = "in-set";
})(LayoutWidth || (exports.LayoutWidth = LayoutWidth = {}));

var LayoutWidthArray = Object.values(LayoutWidth);
exports.LayoutWidthArray = LayoutWidthArray;